import type { SxProps } from "@mui/material"

import { PRIMARY } from "@constants/colors"

const usageConatiner: SxProps = {
  border: "1px #DBDBDB solid",
  borderRadius: 1.5,
  px: 1.5,
  py: 2,
  height: "100%",
  justifyContent: "space-evenly",
  gap: 1
}
const barBase: SxProps = {
  zIndex: 2,
  width: "100%",
  background: "#BFBFBF",
  height: 6,
  borderRadius: 1
}
const barActive: (percent: number, isBlue: boolean) => SxProps = (
  percent,
  isBlue
) => ({
  position: "absolute",
  zIndex: 4,
  width: `${percent}%`,
  background: isBlue ? PRIMARY : percent >= 100 ? "red" : PRIMARY,
  height: 6,
  left: 0,
  bottom: 0,
  borderRadius: 1
})

export default { barBase, barActive, usageConatiner }
